/**
 * The portals of the villages (ADR 0017): one at the heart of every
 * village, in the middle of its square. A player who has used a portal once
 * may travel back to it from anywhere, for a little gold, and may choose it
 * as the place they get back up after a fall.
 */
/** The prop that stands for a portal (`data/props.ts`). */
export const PORTAL_PROP_ID = 'portal';
/** How close to a portal a player must stand to use it, in tiles, diagonals included. */
export const PORTAL_REACH = 2;
/**
 * How long after the last blow, dealt or taken, a player stays in combat:
 * no journey and no mounting meanwhile. The portal is a way home, not a
 * way out of a fight one is losing.
 */
export const TELEPORT_COMBAT_LOCK_MS = 10_000;
/**
 * What a journey costs, by the biome of the village one travels to: a few
 * monsters' worth of loot there (ADR 0016 counts 1,2 to 9,1 gold a monster
 * from the meadow to the snow), so the portal is a convenience, never a
 * wall. The capital is the cheapest: it is home.
 */
export const TELEPORT_COST = Object.freeze({
    meadow: 5,
    forest: 8,
    swamp: 12,
    desert: 18,
    snow: 25,
});
//# sourceMappingURL=portals.js.map